<template>
  <div id="company-layout">
    <ToLoginDialog ref="toLoginDialog"></ToLoginDialog>
    <Header></Header>
    <div class="body">
      <section class="body-left">
        <div class="avatar-box">
          <el-image
            :src="companyAccountDetail.avatar&&companyAccountDetail.avatar.link"
            fit="cover"
            class="u-m-b-20 avatar-img"
            @click="handleAvatar"
          ></el-image>
          <strong class="u-font-16">{{ companyAccountDetail.account }}</strong>
          <div
            v-if="companyDetail.businessLicenseAuditStatus !== undefined"
            class="verify-btn u-flex u-row-center"
            :class="companyDetail.businessLicenseAuditStatus===0?'unverified':companyDetail.businessLicenseAuditStatus===1?'verifying':companyDetail.businessLicenseAuditStatus===2?'verified':'verifyFail'"
          >
            <span
              class="iconfont"
              :class="companyDetail.businessLicenseAuditStatus===0?'icon-weirenzheng':companyDetail.businessLicenseAuditStatus===2?'icon-verified':'icon-weirenzheng'"
            ></span>
            <span
              class="verify-status"
            >{{companyDetail.businessLicenseAuditStatus===0?'未认证':companyDetail.businessLicenseAuditStatus===1?'认证中':companyDetail.businessLicenseAuditStatus===2?'已认证':'已拒绝'}}</span>
          </div>
        </div>
        <div class="menu-box">
          <router-link v-for="item in menus" :key="item.id" :to="item.url" class="menu-link" :class="{ active: $route.path === item.url }">
            <i :class="item.icon" class="icon u-m-r-10"></i>
            <span>{{ item.name }}</span>
          </router-link>
        </div>
      </section>
      <section class="body-right">
        <router-view></router-view>
      </section>
    </div>
    <EditAvatar ref="editAvatar" type="company" @loadAvatar="getDetail" />
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/Header'
import EditAvatar from '@/components/EditAvatar'
import Footer from '@/components/Footer'
import ToLoginDialog from '@/components/ToLoginDialog'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'company-layout',
  components: {
    Header,
    EditAvatar,
    Footer,
    ToLoginDialog
  },

  mounted() {
    // this.loadDetail()
    this.getDetail()
  },
  data() {
    return {
      detail: {},
      menus: [
        { name: '基本资料', url: '/company/baseInfo', icon: 'iconfont icon-gerenziliao' },
        { name: '企业认证', url: '/company/identification', icon: 'iconfont icon-qiyerenzheng' },
        { name: '企业风采', url: '/company/mien', icon: 'iconfont icon-fengcai' },
        { name: '岗位管理', url: '/company/postManage', icon: 'iconfont icon-qiyeguanli_gangweiguanli' },
        { name: '求职简历', url: '/company/resumeManage', icon: 'iconfont icon-jianli' },
        { name: '面试管理', url: '/company/interviewManage', icon: 'iconfont icon-mianshi' },
        { name: '人才库', url: '/company/talentLibrary', icon: 'iconfont icon-a-rencaikurencaiku' }
      ]
    }
  },
  computed: {
    ...mapGetters(['companyDetail', 'companyAccountDetail'])
  },
  methods: {
    ...mapActions(['SetCompanyDetail', 'SetCompanyAccountDetail']),
    // 获取单位详情
    // async loadDetail() {
    //   await this.SetCompanyDetail()
    // },
    // 获取企业账户详情
    getDetail() {
      this.SetCompanyAccountDetail()
    },
    // 点击上传头像
    handleAvatar() {
      this.$refs.editAvatar.open({ avatar: this.companyAccountDetail.avatar.id, avatarUrl: this.companyAccountDetail.avatar.link })
    }
  }
}
</script>

<style lang="scss" scoped>
#company-layout {
  min-width: 1200px;
  min-height: 800px;
  padding: 80px 0 0 0;
  position: relative;
  .body {
    width: 1200px;
    margin: 20px auto;
    height: 100%;
    display: flex;
    .body-left {
      width: 240px;
      height: 100%;
      background-color: #fff;
      margin-right: 20px;
      .avatar-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 40px 0;
        .avatar-img {
          cursor: pointer;
          width: 80px;
          height: 80px;
          border-radius: 50%;
        }
        .verify-btn {
          color: #999;
          width: 100px;
          height: 30px;
          font-size: 14px;
          margin-top: 20px;
          border: 1px solid #cecece;
          border-radius: 4px;
          background: #f5f5f5;
          .verify-status {
            margin-left: 5px;
          }
        }
        .unverified {
          background: #f5f5f5;
          border-color: #cecece;
          color: #999;
        }

        .verifying {
          background: rgba(255, 107, 1, 0.1);
          border-color: #ff6b01;
          color: #ff6b01;
        }
        .verified {
          background: rgba(0, 174, 78, 0.1);
          border-color: #00ae4e;
          color: #00ae4e;
        }
        .verifyFail {
          background: #ffebeb;
          border-color: #ff3636;
          color: #ff3636;
        }
      }
      .menu-box {
        .menu-link {
          height: 50px;
          display: flex;
          align-items: center;
          padding-left: 30px;
          border-right: 6px solid transparent;
          font-size: 16px;
          &:hover {
            color: $primary-color;
            .icon {
              color: $primary-color;
            }
          }
          &.active {
            color: $primary-color;
            border-right: 6px solid $primary-color;
            background-color: #ffede0;
            .icon {
              color: $primary-color;
            }
          }
          .icon {
            color: #999;
          }
        }
      }
    }

    .body-right {
      flex: 1;
      height: 100%;
      overflow-y: auto;
      background-color: #fff;
    }
  }
}
</style>
